module.exports = __webpack_public_path__ + "static/apple-icon-120x120-f0fc896b92d5c47a0405d9e51907c6fb.png";